function toggleClass (selector, className) {
    let element = document.querySelector(selector)
    if (element) {
        element.classList.toggle(className)
    } else {
        console.warn(`${selector} is not available`)
    }
}

export default toggleClass